import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationInvoicesGet = {
    path: "/invoices",
    method: ERouteHttpVerb.GET
};
export { routeLocationInvoicesGet };
